import { render, staticRenderFns } from "./CmNotice.vue?vue&type=template&id=af3c9840"
import script from "./CmNotice.vue?vue&type=script&lang=ts"
export * from "./CmNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports